import Flickity from 'flickity'

export default () => {
    let slider = document.querySelector('body .news-carousel')

    if (!slider) {
        return;
    }

    let options = {
        cellSelector: '.post',
        pageDots: false,
        prevNextButtons: false,
        draggable: '>1',
        watchCSS: false
    }

    const flkty = new Flickity (slider, options)

    window.addEventListener('load', function(event) {
        flkty.resize();
    });

    window.addEventListener('resize', function(event) {
        flkty.resize();
        setSliderHeightToMax(flkty);
    });

    function setSliderHeightToMax(slider) {
        slider.cells.forEach(cell => cell.element.style.height = '');

        let heights = slider.cells.map(cell => cell.element.offsetHeight),
            max = Math.max.apply(Math, heights);

        slider.cells.forEach(cell => cell.element.style.height = max + 'px');
    }

}
